<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FuncionarioModule',
  }
</script>
